import store from '@/store';
import Http from '@/utils/http/index';

export default {

  /**
   * 付款列表
   * @param {*} params
   * @returns
   */
  getTransferList(params) {
    return Http.get('/payoutMerchant/list', { params });
  },

  /**
   * 下载付款列表
   * @param {*} params
   */
  async downloadTransferList(params) {
    return Http.get('/payoutMerchant/download', { params });
  },

  /**
   * 付款详情
   * @param {*} id
   * @returns
   */
  getTransferInfo(id) {
    let prefix = '';
    const merchantType = store.getters.app.userLogin && store.getters.app.userLogin.merchantType ? store.getters.app.userLogin.merchantType : '';
    try {
      if (`${merchantType}` === '3') { // 集团商户时，需要判断是否更换接口
        prefix = '/blocMer';
      } else if (`${merchantType}` === '2') { // 代理商
        prefix = '/proxyMer';
      }
    } catch (err) {
      //
    }
    return Http.get(`${prefix}/payoutMerchant/info/${id}`);
  },

  /**
   * 付款证明材料
   */
  uploadCertificateFile(file) {
    const param = new FormData(); // 创建form对象
    param.append('file', file);
    return Http.post('/payoutMerchant/upload', param, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  /**
   * 获取付款手续费
   * @returns
   */
  getTransferFee(data) {
    return Http.post('/payoutMerchant/fee', data);
  },

  /**
   * 反向获取付款手续费
   * @returns
   */
  getTransferReverseFee(data) {
    return Http.post('/payoutMerchant/fee/reverse', data);
  },

  getTransferResult(data) {
    return Http.post('/payoutMer/payout/exchangePayout', data);
  },

  getTransferReverseResult(data) {
    return Http.post('/payoutMer/payout/exchangePayout/reverse', data);
  },

  /**
   * 发送付款邮件
   * @returns
   */
  sendTransferVerifyCode() {
    return Http.get('/payoutMerchant/captcha');
  },

  /**
   * 付款提交
   * @param {*} data
   * @returns
   */
  autoPayout(data) {
    return Http.post('/payoutMerchant/autoPayout', data);
  },

  /**
   * B2B 付款方列表
   */
  getPayerVaList(params) {
    return Http.get('/merchantVaApply/merchantValidList', { params });
  },

  /**
   * 批量下发
   */
  batchPaymentUpload(file) {
    const param = new FormData(); // 创建form对象
    param.append('file', file);
    return Http.post('/payoutMerchant/batchPaymentUpload', param, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  // 上传批量付款
  batchPaymentVerif(file) {
    const param = new FormData(); // 创建form对象
    param.append('file', file);
    return Http.post('/payment/batchPaymentVerify', param, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  // 异步批量校验
  queryVerifyResult(params = {}) {
    return Http.get('/merchant/payment/queryVerifyResult', { params });
  },
  // 取消异步校验
  stopVerify(params = {}) {
    return Http.post('/merchant/payment/stopVerify', params);
  },
  /**
   * 确认批量下发
   */
  batchPayment(file, { taskId, requestId, verifyCode }) {
    const param = new FormData(); // 创建form对象
    param.append('file', file);
    param.append('requestId', requestId);
    param.append('verifyCode', verifyCode);
    param.append('taskId', taskId);
    return Http.post('/payoutMerchant/batchPayment', param, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  /**
   * 批量下载付款凭证
   * @param {*} params
   * @returns
   */
  batchDownloadCertificate(params = {}) {
    return Http.get('/payoutMerchant/payoutVoucherBatch', { params });
  },

  /**
   * 下载付款凭证
   * @param {*} params
   * @returns
   */
  async downloadCertificate(params = {}) {
    const res = await Http.get('/payoutMerchant/payoutVoucher', { params });
    if (res && res.startsWith('http')) {
      window.location.href = res;
    }
    return res;
  },

  querySafetyReviewPayoutBill(data) {
    return Http.post('/payment/safetyReviewPayoutBill', data);
  },

  queryPayoutRouteMethod(data = {}) {
    return Http.post('/merchant/payee/routeCheck', data);
  },

  queryPaymentRouteMethod(data = {}) {
    return Http.post('/payment/routeCheck', data);
  },
  // 付款方名称
  querylistPayer(data = {}) {
    return Http.get('/merchant/payment/listPayer', data);
  },
};
